import { first } from 'lodash';

const DEFAULT_LOCALE = 'en';

const LOCALE_BYPASS = {
    'nn': 'no',
    'nb': 'no'
}

export default function getDefaultLanguage(languageDefault) {
    let userLanguage = DEFAULT_LOCALE;

    if (navigator) {
        let clientLanguage = first((navigator.language || navigator.userLanguage).split('-'));

        if (LOCALE_BYPASS[clientLanguage]) {
            clientLanguage = LOCALE_BYPASS[clientLanguage];
        }

        if (clientLanguage === languageDefault) {
            userLanguage = clientLanguage;
        }
    }

    return userLanguage;
}
